(function () {
  function setup(sc) {
    if (sc.__pgDone) return;
    var slider = sc.querySelector('.slider');
    if (!slider || slider.children.length < 2) return;
    sc.__pgDone = true;
    var items = slider.children;
    function off() { return items[1].offsetLeft - items[0].offsetLeft; }
    function per() {
      var o = off();
      return o > 0 ? Math.max(1, Math.round(slider.clientWidth / o)) : 5;
    }
    function counter() {
      var n = per();
      var total = Math.max(1, Math.ceil(items.length / n));
      var cur = Math.min(total, Math.round(slider.scrollLeft / (off() * n)) + 1);
      if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2) { cur = total; }
      var c = sc.querySelector('.slider-counter--current');
      var t = sc.querySelector('.slider-counter--total');
      if (c && c.textContent != String(cur)) c.textContent = cur;
      if (t && t.textContent != String(total)) t.textContent = total;
    }
    sc.querySelectorAll('.slider-button').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var page = per() * off();
        var max = slider.scrollWidth - slider.clientWidth;
        var dir = b.name === 'next' ? 1 : -1;
        slider.scrollTo({ left: Math.max(0, Math.min(max, slider.scrollLeft + dir * page)), behavior: 'smooth' });
      }, true);
    });
    var mo = new MutationObserver(counter);
    ['.slider-counter--current', '.slider-counter--total'].forEach(function (s) {
      var el = sc.querySelector(s);
      if (el) mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
    counter();
    [100, 400, 1000, 2500].forEach(function (ms) { setTimeout(counter, ms); });
    slider.addEventListener('scroll', function () { requestAnimationFrame(counter); }, { passive: true });
    window.addEventListener('resize', counter);
    window.addEventListener('load', counter);
  }
  function init() { document.querySelectorAll('slider-component').forEach(setup); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);

  /* Mark the Contact page so its heading can sit closer to the form */
  if (location.pathname.replace(/\/$/, '') === '/pages/contact') { document.documentElement.classList.add('is-contact'); }

  /* Extra styles: clickable collection cards, space under policy pages, wider and rounded collage pictures, 6 products on phones, 4 cards in the Bath and Curtains row, larger collage labels, tighter pillow row, larger page arrows, half-size hover jump on collection titles, closer Contact heading */
  var st = document.createElement('style');
  st.textContent = '.collage__item--collection .card-wrapper,.collection-card-wrapper{cursor:pointer}' +
    '.collage__item .card__inner,.collage__item .card__inner .media{border-radius:.5rem;overflow:hidden}' +
    '.collage__item--collection .card__heading{font-size:2.8rem!important;line-height:1.25!important;color:rgb(var(--color-foreground));text-shadow:none!important}' +
    '.collage__item--collection .card__heading a{color:rgb(var(--color-foreground))}' +
    '.collection-card-wrapper:hover .card__heading,.collection-card-wrapper:focus-within .card__heading,.collage__item--collection .card-wrapper:hover .card__heading,.collage__item--collection .card-wrapper:focus-within .card__heading{transform:translateY(-1.5px) scale(1.025)!important}' +
    '[id$=\'__featured-collection\'] .slider.grid{margin-bottom:0!important}' +
    '[id$=\'__featured-collection\'] .slider-buttons{margin-top:.2rem!important;margin-bottom:0!important}' +
    'slider-component .slider-buttons{zoom:1.1}' +
    '.is-contact .main-page-title{margin-bottom:0!important}' +
    '.is-contact .main-page-title + .rte{display:none}' +
    '.is-contact .page-width:has(> .main-page-title){padding-bottom:0!important}' +
    '.is-contact .contact{margin-top:1.6rem}' +
    '.shopify-policy__container{padding-bottom:8rem}' +
    '@media screen and (max-width:749px){.collage__item--collection .card__heading{font-size:2rem!important}.shopify-policy__container{padding-bottom:5rem}' +
    'slider-component .slider>.grid__item:nth-child(n+7){display:none!important}' +
    'slider-component .slider-buttons{display:none!important}}' +
    '@media screen and (min-width:750px){.page-width:has(> .collage){max-width:min(100vw, calc((100vw + var(--page-width)) / 2 + 5rem))}' +
    '[id$=\'__featured-collection-2\'] .slider.slider--desktop>.grid__item{flex:0 0 calc((100% - 3 * var(--grid-desktop-horizontal-spacing)) / 4)!important;width:calc((100% - 3 * var(--grid-desktop-horizontal-spacing)) / 4)!important}}';
  document.head.appendChild(st);

  /* Make the whole collection card (picture and name) clickable */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.collage__item--collection .card-wrapper, .collection-card-wrapper');
    if (!card) return;
    if (t.closest('a, button')) return;
    var a = card.querySelector('.card__heading a, a.full-unstyled-link');
    if (a && a.href) { window.location.href = a.href; }
  });
})();